import { createSelector } from '@reduxjs/toolkit';

import { ReducerState } from '../common/lib/reducerState';
import { AuthState } from './authState';

export const selectAuthState = (state: ReducerState) => state.auth;

export const selectDisplayFoldedCardsEnabled = createSelector(
  [selectAuthState],
  (auth: AuthState) => auth.settings?.displayFoldedCardsEnabled,
);

export const selectSmartWalletAddress = createSelector([selectAuthState], (auth: AuthState) => auth.smartWalletAddress);
